import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';

function getPercent(percent) {
  if (percent > 100 || percent < 0 || typeof percent !== 'number') {
    console.warn(
      `[ui-kit-progress-bar]: The value passed to percent needs to be a number between 0 and 100 (passed value: ${percent}).`,
    );
  }
  return Math.min(100, Math.max(percent, 0));
}

const ProgressBar = ({
  percent,
  filledColor,
  unfilledColor,
  width,
  height,
  label,
  ...rest
}) => {
  const progressBar = useRef();
  const classes = useStyle({
    height, width, filledColor, unfilledColor,
  });

  const safePercent = getPercent(percent);

  useEffect(() => {
    progressBar.current.style.setProperty(
      'width',
      `${safePercent}%`,
    );
  }, [percent]);

  return (
    <div className={classes.progressBar} {...rest}>
      <div ref={progressBar} className="progress">{label}</div>
    </div>
  );
};

ProgressBar.propTypes = {
  percent: PropTypes.number.isRequired,
  /** The width of the progress bar in pixel */
  width: PropTypes.number,
  /** The height of the progress bar in pixel */
  height: PropTypes.number,
  /** One of keys that passed to ThemeProvider as colors */
  filledColor: PropTypes.string,
  /** One of keys that passed to ThemeProvider as colors */
  unfilledColor: PropTypes.string,
  label: PropTypes.string,
};

ProgressBar.defaultProps = {
  width: null,
  height: 6,
  label: null,
  filledColor: 'primary2',
  unfilledColor: 'primary2',
};

export default ProgressBar;
